import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import foodsDetailsAPI from '../services/foodsDetailsAPI';
import drinksDetailsAPI from '../services/drinksDetailsAPI';
import context from '../context/recipesContext';

function FinishButton({ id, type }) {
  const history = useHistory();
  const { doneRecipes } = useContext(context);
  const [recipe, setRecipe] = useState({});
  const [done, setDone] = useState({});

  useEffect(() => {
    const fetchMeals = async () => {
      if (type === 'food') {
        const getMeal = await foodsDetailsAPI(id);
        setRecipe(await getMeal);
      } else {
        const getDrink = await drinksDetailsAPI(id);
        setRecipe(await getDrink);
      }
    };
    fetchMeals();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (type === 'food') {
      setDone({
        id: recipe.idMeal,
        type: 'food',
        nationality: recipe.strArea,
        category: recipe.strCategory,
        alcoholicOrNot: '',
        name: recipe.strMeal,
        image: recipe.strMealThumb,
        doneDate: '',
      });
    } else {
      setDone({
        id: recipe.idDrink,
        type: 'drink',
        nationality: recipe.strArea,
        category: recipe.strCategory,
        alcoholicOrNot: recipe.strAlcoholic,
        name: recipe.strDrink,
        image: recipe.strDrinkThumb,
        doneDate: '',
      });
    }
  }, [recipe, type]);

  const finishRecipe = () => {
    const date = new Date();
    const day = String(date.getDate());
    const month = String(date.getMonth() + 1);
    const doneDate = `${day} / ${month} / ${String(date.getFullYear())}`;
    // setDone();
    const thisRecipe = { ...done, doneDate };
    localStorage.setItem(
      'doneRecipes', JSON.stringify([...doneRecipes, thisRecipe]),
    );
    history.push('/done-recipes');
  };

  return (
    <div>
      <button
        type="button"
        className="finish-btn"
        data-testid="finish-recipe-btn"
        onClick={ finishRecipe }
      >
        Finish Recipe
      </button>
    </div>
  );
}

FinishButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default FinishButton;
